var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.wrap, _vm.fullScreen && _vm.$style.fullScreen]},[_c('header',[_c('span',[_vm._v(_vm._s(_vm.affiche_info.title))])]),_c('main',[_c('p',[_vm._v(_vm._s(_vm.affiche_info.text))]),_c('div',{class:_vm.$style.btnWrap},[_c('button',{class:_vm.$style.btn,on:{"click":_vm.turnoff}},[_vm._v(_vm._s(_vm.btnText))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }